import { Injectable } from '@angular/core';
import {ParamMap} from "@angular/router";
import {JwtService, UserSessionService} from "old-frontend-auth-ws";
import {CookieService} from "ngx-cookie-service";
import {CompressionService} from "./compression.service";



@Injectable({
  providedIn: 'root'
})
export class KeycloakService {
  private success: string;
  private error: string;
  private tokenId: string;
  private refreshToken: string;
  private sessionId: string;
  private sessionTimeOut: string;
  private lastLogon: string;

  constructor(private jwtService: JwtService,
              private userSession: UserSessionService,
              private cookieService: CookieService,
              private compressionService: CompressionService) {
  }

  setKeycloakAuth(snapshot: ParamMap) {
    this.success = snapshot.get('success');

    if (this.isKeycloakSuccess) {
      const deflateToken = this.cookieService.get('TOKEN_ID_DEF');

      this.refreshToken = this.cookieService.get('REFRESH_TOKEN');
      this.tokenId = this.compressionService.decompressBase64(deflateToken);
      this.sessionId = snapshot.get('sessionId');
      this.sessionTimeOut = String(Number(snapshot.get('sessionTimeout')) * 60);
      this.lastLogon = snapshot.get('lastSystemLogon');
      this.jwtService.saveToken(this.tokenId, this.refreshToken);
      this.userSession.setUserSession({sessionId: this.sessionId, sessionTimeOut: this.sessionTimeOut});
      this.keycloakOption = true;
    } else {
      this.error = snapshot.get('error');
    }

  }

  get keycloakToken(): string {
    return this.tokenId || '';
  }

  get isKeycloakSuccess(): boolean {
    return this.success === 'true';
  }

  set keycloakOption(option: boolean) {
    sessionStorage.setItem('openid', String(option));
  }

  get keycloakOption(): boolean {
    return sessionStorage.getItem('openid') === 'true';
  }

  get errorMessage(): string {
    return this.error;
  }

  get lastUserLogon(): string {
    return this.lastLogon;
  }
}
